/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
import * as i0 from "@angular/core";
import * as i1 from "./menu-xxss";
import * as i2 from "ionic-angular/navigation/nav-controller";
import * as i3 from "ionic-angular/navigation/nav-params";
var styles_MenuXxssPage = [];
var RenderType_MenuXxssPage = i0.ɵcrt({ encapsulation: 2, styles: styles_MenuXxssPage, data: {} });
export { RenderType_MenuXxssPage as RenderType_MenuXxssPage };
export function View_MenuXxssPage_0(_l) { return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, 0, null, null, 0, "img", [["src", "./assets/images/pascual/compartir_pascual-01.png"], ["width", "100%"]], null, [[null, "click"]], function (_v, en, $event) { var ad = true; var _co = _v.component; if (("click" === en)) {
        var pd_0 = (_co.onBack() !== false);
        ad = (pd_0 && ad);
    } return ad; }, null, null))], null, null); }
export function View_MenuXxssPage_Host_0(_l) { return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, 0, null, null, 1, "page-menu-xxss", [], null, null, null, View_MenuXxssPage_0, RenderType_MenuXxssPage)), i0.ɵdid(1, 49152, null, 0, i1.MenuXxssPage, [i2.NavController, i3.NavParams], null, null)], null, null); }
var MenuXxssPageNgFactory = i0.ɵccf("page-menu-xxss", i1.MenuXxssPage, View_MenuXxssPage_Host_0, {}, {}, []);
export { MenuXxssPageNgFactory as MenuXxssPageNgFactory };
//# sourceMappingURL=menu-xxss.ngfactory.js.map


//////////////////
// WEBPACK FOOTER
// ./src/pages/menu/menu-xxss/menu-xxss.ngfactory.js
// module id = null
// module chunks = 